import React, { useState } from 'react';
import { parseBrazilianNumber } from '../../../utils/formatUtils';
import { FormField, ResultCard } from '../finance/shared';

const MacronutrientsCalculator = ({ onResultChange }: { onResultChange: (data: { label: string, value: string }[]) => void }) => {
  const [cals, setCals] = useState('2.000');
  const [goal, setGoal] = useState('maintain');
  const [res, setRes] = useState<any>(null);

  const calculate = () => {
    const c = parseFloat(parseBrazilianNumber(cals)) || 0;
    if (c <= 0) return;

    let p = 0.2, k = 0.5, g = 0.3;
    if (goal === 'weight_loss') { p = 0.3; k = 0.4; g = 0.3; }
    else if (goal === 'muscle_gain') { p = 0.25; k = 0.5; g = 0.25; }

    const prot = (c * p) / 4;
    const carb = (c * k) / 4;
    const fat = (c * g) / 9;

    setRes({ prot: Math.round(prot), carb: Math.round(carb), fat: Math.round(fat) });
    onResultChange([
      { label: 'Proteínas', value: `${Math.round(prot)}g` },
      { label: 'Carboidratos', value: `${Math.round(carb)}g` },
      { label: 'Gorduras', value: `${Math.round(fat)}g` }
    ]);
  };

  return (
    <div className="space-y-8">
      <div className="bg-theme-result p-6 rounded-2xl border border-theme-border text-center font-black text-theme-text uppercase tracking-widest">
        Macronutrientes
      </div>
      <div className="bg-theme-result p-8 rounded-3xl border border-theme-border shadow-sm">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <FormField label="Calorias Diárias" value={cals} onChange={setCals} isInteger required type="text" />
          <FormField label="Objetivo" value={goal} onChange={setGoal} type="select" options={[
            { value: 'maintain', label: 'Manutenção' },
            { value: 'weight_loss', label: 'Emagrecer' },
            { value: 'muscle_gain', label: 'Hipertrofia' }
          ]} />
        </div>
        <div className="flex justify-center mt-8">
          <button onClick={calculate} className="px-10 py-4 bg-accent-gradient text-white rounded-xl font-bold shadow-accent hover:scale-105 transition-all">Calcular</button>
        </div>
      </div>
      {res && (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <ResultCard title="Proteínas" value={`${res.prot}g`} color="blue" />
          <ResultCard title="Carboidratos" value={`${res.carb}g`} color="green" />
          <ResultCard title="Gorduras" value={`${res.fat}g`} color="amber" />
        </div>
      )}
    </div>
  );
};

export default MacronutrientsCalculator;
